module.exports = __webpack_public_path__ + "static/media/sheet-composite.enc.c54111ee.png";